'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _chemist = require('chemist');

var _FormInput = require('../FormInput');

var _CountryTooltip = require('../CountryTooltip');

var _CountryTooltip2 = _interopRequireDefault(_CountryTooltip);

var _address = require('../../helpers/address');

var _addressForm = require('../../actions/addressForm');

var _EnterAddressFormStyle = require('./EnterAddressFormStyle.scss');

var _EnterAddressFormStyle2 = _interopRequireDefault(_EnterAddressFormStyle);

var _StreetHousenumberField = require('./StreetHousenumberField');

var _StreetHousenumberField2 = _interopRequireDefault(_StreetHousenumberField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressFormFields = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactRedux.connect)(function (state, props) {
  return {
    addressDetails: state.addressForm.addressDetails[props.prefix]
  };
}), _dec3 = (0, _reactI18next.translate)(), _dec4 = (0, _reactCssModules2.default)(_EnterAddressFormStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressFormFields, _React$Component);

  function AddressFormFields() {
    (0, _classCallCheck3.default)(this, AddressFormFields);
    return (0, _possibleConstructorReturn3.default)(this, (AddressFormFields.__proto__ || (0, _getPrototypeOf2.default)(AddressFormFields)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressFormFields, [{
    key: 'addressAttribute',
    value: function addressAttribute(name) {
      var _props = this.props,
          prefix = _props.prefix,
          order = _props.order,
          addressDetails = _props.addressDetails;

      return (0, _address.addressValueFor)(prefix, name, addressDetails, order);
    }
  }, {
    key: 'formErrors',
    value: function formErrors() {
      return this.props.errors || {};
    }
  }, {
    key: 'updateField',
    value: function updateField(fieldName, value) {
      this.props.onFieldChange(fieldName, value);
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(fieldName, e) {
      this.updateField(fieldName, e.currentTarget.value);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(fieldName, e) {
      this.handleValueChange(fieldName, e.target.value);
    }
  }, {
    key: 'handleValueChange',
    value: function handleValueChange(fieldName, value) {
      this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, fieldName, value));
      this.updateField(fieldName, value);
    }
  }, {
    key: 'stateOptionValues',
    value: function stateOptionValues() {
      var t = this.props.t;

      var states = (0, _lodash.map)(this.props.country.states, function (state) {
        return [state.name, state.name];
      });

      states.unshift(['', t('checkout_please_select')]);
      return states;
    }
  }, {
    key: 'stateInput',
    value: function stateInput() {
      if (this.props.country.states.length > 0) {
        return _react2.default.createElement(_FormInput.Select, {
          id: this.props.prefix + 'AddressStateName',
          name: 'order[' + this.props.prefix + '_address_attributes][state_name]',
          defaultValue: this.addressAttribute('state_name'),
          onChange: this.handleKeyUp.bind(this, 'stateName'),
          required: this.props.country.statesRequired,
          options: this.stateOptionValues()
        });
      }

      return _react2.default.createElement(_FormInput.Input, {
        id: this.props.prefix + 'AddressStateName',
        name: 'order[' + this.props.prefix + '_address_attributes][state_name]',
        defaultValue: this.addressAttribute('state_name'),
        onInput: this.handleKeyUp.bind(this, 'state_name'),
        onKeyUp: this.handleKeyUp.bind(this, 'state_name'),
        required: this.props.country.statesRequired
      });
    }
  }, {
    key: 'handleZipcodeChange',
    value: function handleZipcodeChange(e) {
      this.handleChange('zipcode', e);
      this.handleKeyUp('zipcode', e);
    }
  }, {
    key: 'renderStateField',
    value: function renderStateField() {
      var t = this.props.t;


      return _react2.default.createElement(
        _FormInput.Field,
        {
          additionalStyles: 'm-formField--lg-right',
          inputName: this.props.prefix + 'AddressStateName',
          errors: this.formErrors(),
          inputLabel: t('spree.state'),
          fieldRequired: this.props.country.statesRequired
        },
        this.stateInput()
      );
    }
  }, {
    key: 'renderFreeAddressField',
    value: function renderFreeAddressField() {
      var _props2 = this.props,
          t = _props2.t,
          prefix = _props2.prefix;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: prefix + 'AddressAddress1',
            errors: this.formErrors(),
            inputLabel: t('spree.street_address'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressAddress1',
            name: 'order[' + prefix + '_address_attributes][address1]',
            value: this.addressAttribute('address1'),
            onChange: this.handleChange.bind(this, 'address1'),
            required: true
          })
        )
      );
    }
  }, {
    key: 'renderStreetHousenumberAddressField',
    value: function renderStreetHousenumberAddressField() {
      var _props3 = this.props,
          t = _props3.t,
          prefix = _props3.prefix,
          errors = _props3.errors;

      return _react2.default.createElement(_StreetHousenumberField2.default, {
        t: t,
        prefix: prefix,
        errors: errors,
        id: prefix + 'AddressAddress1',
        name: 'order[' + prefix + '_address_attributes][address1]',
        address: this.addressAttribute('address1') || '',
        onChange: this.handleValueChange.bind(this, 'address1'),
        required: true
      });
    }
  }, {
    key: 'renderAddressField',
    value: function renderAddressField() {
      if (this.props.config.store.addressWithHousenumber) {
        return this.renderStreetHousenumberAddressField();
      }
      return this.renderFreeAddressField();
    }
  }, {
    key: 'renderAddressField2',
    value: function renderAddressField2() {
      var _props4 = this.props,
          t = _props4.t,
          prefix = _props4.prefix;


      return _react2.default.createElement(
        _FormInput.Field,
        {
          inputName: prefix + 'AddressAddress2',
          errors: this.formErrors(),
          inputLabel: t('spree.street_address_2')
        },
        _react2.default.createElement(_FormInput.Input, {
          id: prefix + 'AddressAddress2',
          name: 'order[' + prefix + '_address_attributes][address2]',
          defaultValue: this.addressAttribute('address2'),
          onChange: this.handleChange.bind(this, 'address2')
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          t = _props5.t,
          prefix = _props5.prefix,
          config = _props5.config,
          country = _props5.country;
      var store = config.store,
          theme = config.theme;
      var statesRequired = country.statesRequired;


      var companyStyleName = store.code === 'edeexp' ? 'm-formField--companyName-sikkens' : 'm-formField--companyName';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: companyStyleName,
            inputName: this.props.prefix + 'AddressCompanyname',
            errors: this.formErrors(),
            inputLabel: t('spree.company_name')
          },
          _react2.default.createElement(_FormInput.Input, {
            id: this.props.prefix + 'AddressCompanyname',
            name: 'order[' + this.props.prefix + '_address_attributes][company]',
            defaultValue: this.addressAttribute('companyname'),
            onKeyUp: this.handleKeyUp.bind(this, 'companyname'),
            onChange: this.handleChange.bind(this, 'companyname'),
            onInput: this.handleKeyUp.bind(this, 'companyname')
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: prefix + 'AddressFirstname',
            errors: this.formErrors(),
            inputLabel: t('spree.first_name'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressFirstname',
            name: 'order[' + prefix + '_address_attributes][firstname]',
            defaultValue: this.addressAttribute('firstname'),
            onKeyUp: this.handleKeyUp.bind(this, 'firstName'),
            onInput: this.handleKeyUp.bind(this, 'firstName'),
            onChange: this.handleChange.bind(this, 'firstName'),
            required: true
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: prefix + 'AddressLastname',
            errors: this.formErrors(),
            inputLabel: t('spree.last_name'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressLastname',
            name: 'order[' + prefix + '_address_attributes][lastname]',
            defaultValue: this.addressAttribute('lastname'),
            onKeyUp: this.handleKeyUp.bind(this, 'lastName'),
            onInput: this.handleKeyUp.bind(this, 'lastName'),
            onChange: this.handleChange.bind(this, 'lastName'),
            required: true
          })
        ),
        this.renderAddressField(),
        store.secondAddress && this.renderAddressField2(),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: statesRequired || theme === 'woodcare' ? 'm-formField--lg-left' : '',
            inputName: this.props.prefix + 'AddressCity',
            errors: this.formErrors(),
            inputLabel: t('spree.city'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: this.props.prefix + 'AddressCity',
            name: 'order[' + this.props.prefix + '_address_attributes][city]',
            defaultValue: this.addressAttribute('city'),
            onChange: this.handleChange.bind(this, 'city'),
            required: true
          })
        ),
        statesRequired && this.renderStateField(),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: statesRequired || theme !== 'woodcare' ? 'm-formField--lg-left' : 'm-formField--lg-right',
            inputName: prefix + 'AddressZipcode',
            errors: this.formErrors(),
            inputLabel: t('spree.zipcode'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressZipcode',
            name: 'order[' + prefix + '_address_attributes][zipcode]',
            defaultValue: this.addressAttribute('zipcode'),
            onChange: this.handleZipcodeChange.bind(this),
            required: true
          }),
          _react2.default.createElement(
            'div',
            { styleName: 'm-tooltip' },
            _react2.default.createElement(_CountryTooltip2.default, { country: this.props.country })
          )
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: statesRequired || theme !== 'woodcare' ? 'm-formField--lg-right' : '',
            inputName: prefix + 'AddressPhone',
            errors: this.formErrors(),
            inputLabel: t('spree.phone'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressPhone',
            name: 'order[' + prefix + '_address_attributes][phone]',
            defaultValue: this.addressAttribute('phone'),
            onKeyUp: this.handleKeyUp.bind(this, 'phone'),
            onInput: this.handleKeyUp.bind(this, 'phone'),
            onChange: this.handleChange.bind(this, 'phone'),
            required: true,
            type: 'tel',
            pattern: '^[\\d\\s]+$'
          })
        )
      );
    }
  }]);
  return AddressFormFields;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  country: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object,
  prefix: _react.PropTypes.string.isRequired,
  onFieldChange: _react.PropTypes.func.isRequired
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = AddressFormFields;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/AddressFormFields.js
// module id = 2261
// module chunks = 0